import { dispatch } from "./utils/dispatch";

export const of = dispatch("of");
export const flatten = dispatch("flatten");
export const map = dispatch("map");
export const mapError = dispatch("mapError");
export const flatMap = dispatch("flatMap");
export const apply = dispatch("apply");
export const fold = dispatch("fold");
export const foldl = dispatch("foldl");
export const foldr = dispatch("foldr");
export const filter = dispatch("filter");
export const find = dispatch("find");
export const some = dispatch("some");
export const every = dispatch("every");
export const getDispatch = dispatch("get");
export const getIn = dispatch("getIn");
export const concat = dispatch("concat");
